import { ConfigProvider } from 'antd';
import { Suspense, useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';

import { LOCAL_STORAGE_KEY } from './core/constants';

import '~/App.scss';

import FullPageLoader from '~/UI/components/templates/FullPageLoader';
import GTM_ID_BY_URL from '~/core/constants/gtmIdByUrl';
import HOTJAR_ID_BY_URL from '~/core/constants/hotjarIdByUrl';
import { removeLocalData, setLocalData } from '~/core/helpers/storageHelper';
import { useGoogleTagManager } from '~/core/hooks/useGoogleTagManager';
import useHotJar from '~/core/hooks/useHotJar';
import i18n from '~/core/i18n/i18n';
import { persistor, store } from '~/redux/store';
import RouterDom from '~/router';
import { ThemeProvider } from '~/theme';
import { ContextProvider } from '~contexts';

const App = (): JSX.Element => {
  useGoogleTagManager({ gtmIdByUrl: GTM_ID_BY_URL });
  useHotJar({ hotJarIdByUrl: HOTJAR_ID_BY_URL });

  // TODO: uncomment this once the EPM functionality is complete
  // useEquivalentMatchingDisabled();

  useEffect(() => {
    setLocalData(LOCAL_STORAGE_KEY.KEEP_LOAD_ESTIMATE_IN_URL, false);
    removeLocalData(LOCAL_STORAGE_KEY.LOAD_ESTIMATE);
    removeLocalData(LOCAL_STORAGE_KEY.ESTIMATE_CODE_SWITCH);
  }, []);

  return (
    <ConfigProvider theme={{ hashed: false }}>
      <Suspense fallback={<FullPageLoader />}>
        <I18nextProvider i18n={i18n}>
          <Provider store={store}>
            <BrowserRouter>
              <ContextProvider>
                <ThemeProvider>
                  <PersistGate
                    loading={<FullPageLoader />}
                    persistor={persistor}
                  >
                    <RouterDom />
                  </PersistGate>
                </ThemeProvider>
              </ContextProvider>
            </BrowserRouter>
          </Provider>
        </I18nextProvider>
      </Suspense>
    </ConfigProvider>
  );
};

export default App;
